export default "__VITE_ASSET__Cesrhd4z__"